import { CERTAINTY_LEVEL } from './CertaintyLevel';
import { AVAILABLE_SEGMENTATIONS } from './AvailableSegmentations';

const constants = {
  CERTAINTY_LEVEL,
  AVAILABLE_SEGMENTATIONS,
};

export { constants };
